import React from 'react';
import styled from 'styled-components';

const BaseStyledDiv = styled.div`
  width: 100%;
  overflow: auto;
`;

const MainStyledDiv = styled.div`
  background-color: #dcf3ff;
  font-size: 14px;
  margin-bottom: 24px;
  word-break: break-all;
  margin-left: ${(props: { isWide: boolean }) =>
    props.isWide ? '30%' : '51px'};
  border-radius: ${(props: { isWide: boolean }) => (props.isWide ? 13 : 51)}px;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: right;
      margin-right: 2%;
      padding-bottom: 2%;
      padding-top: 3%;
      width: 61%;`
      : ``}
`;

interface Props {
  children: any;
  isWide: boolean;
  lastMessageDivRef?: React.RefObject<HTMLDivElement>;
}

export const ChatRight = (props: Props) => {
  const { children, isWide } = props;

  return (
    <BaseStyledDiv>
      <MainStyledDiv isWide={isWide}>{children}</MainStyledDiv>
    </BaseStyledDiv>
  );
};
